import React from 'react'

import { loginPath } from '~/common/define/path'
import OpenPageHead from '~/components/header/OpenPageHead'
import LoginPage from '~/components/page/login/LoginPage'
import StandardLayout from '~/components/layout/StandardLayout'
import PageFrame from '~/components/wrapper/screen/PageFrame'
import { useTranslation } from 'react-i18next'

interface Props {
  redirect?: boolean
}

const LoginLayoutPage = ({redirect = false}: Props) => {
  const {t} = useTranslation()

  return (
    <StandardLayout noBackGround>
      <OpenPageHead title={t('login:head_title')} seoPath={redirect ? null : loginPath()} seoOn={!redirect}/>
      <PageFrame>
        <LoginPage/>
      </PageFrame>
    </StandardLayout>
  )
}

export default LoginLayoutPage